import axios from 'axios';
import { token } from '@/services/useToken';
import { clearAllTokens } from '@/services/auth';

const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const API_BASE_URL = isLocalhost
  ? "http://localhost/byc-takip/api/app/"
  : "https://takip.gifadwork.com/api/app/";

const axiosCustom = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data'
  },
});

// Request interceptor - her istekte token'ı dinamik olarak ekle
axiosCustom.interceptors.request.use(
  (config) => {
    if (token.value) {
      config.headers.Authorization = `Bearer ${token.value}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - 401 hatası durumunda login sayfasına yönlendir
axiosCustom.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token geçersiz, login sayfasına yönlendir
      clearAllTokens();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosCustom;